import React from "react";

import { Button, Divider, Popover } from "antd";
import {
  CarryOutOutlined, DeleteOutlined, DownloadOutlined, FieldTimeOutlined, MoreOutlined, PauseOutlined, ReloadOutlined,
} from "@ant-design/icons";

const markOptions = [
  { label: "Mark as Pending", value: 0, icon: <FieldTimeOutlined /> },
  { label: "Mark as Approve", value: 1, icon: <CarryOutOutlined /> },
  { label: "Mark as Hold", value: 2, icon: <PauseOutlined /> },
  { label: "Mark as Retesting", value: 3, icon: <ReloadOutlined /> },
];

const moveOptions = [
  {
    label: "Move to Available Tab", value: "available", icon: <CarryOutOutlined />, tab: "hold",
  },
  {
    label: "Move to Pending Tab", value: "pending", icon: <FieldTimeOutlined />, tab: "available",
  },
  {
    label: "Move to Hold Tab", value: "hold", icon: <PauseOutlined />, tab: "available",
  },
];

const qcOptions = [
  // { label: "Run QC", value: false, icon: <PlaySquareOutlined /> },
  { label: "ReRun QC", value: true, icon: <ReloadOutlined /> },
];

export default function ActionPopup({
  tab, counter, user, loading, onDownloadClick, showMarkConfirmation, showQcConfirmation, handleMove, onRemoveClick,
}) {
  const showMoveOptions = moveOptions.length > 0 && ["available", "hold"].includes(tab);

  const actionPopupMenu = (
    <div className="SendReportActionPopoverContent">
      <div className="popover-field">
        <label>QC</label>
        <div className="field-options">
          {qcOptions.map((option, i) => {
            const { label, value, icon } = option;
            return (
              <Button key={i} className="field-button" type="text" icon={icon} onClick={() => showQcConfirmation(value)}>{label}</Button>
            );
          })}
        </div>
      </div>
      {markOptions.length > 0 && tab !== "history" && (
        <div className="popover-field">
          <label>Mark</label>
          <div className="field-options">
            {markOptions.map((option, i) => {
              const { label, icon, value } = option;
              return (
                <Button
                  key={i}
                  className="field-button"
                  type="text"
                  icon={icon}
                  onClick={() => showMarkConfirmation(value)}
                >
                  {label}
                </Button>
              );
            })}
          </div>
        </div>
      )}
      {showMoveOptions && tab !== "history" && (
        <>
          <Divider className="divider" />
          <div className="popover-field">
            <label>Move</label>
            <div className="field-options">
              {moveOptions.filter((item) => !item.tab || item.tab === tab).map((option, i) => {
                const { label, icon, value } = option;
                return (
                  <Button
                    key={i}
                    className="field-button"
                    type="text"
                    icon={icon}
                    onClick={() => handleMove(value)}
                  >
                    {label}
                  </Button>
                );
              })}
            </div>
          </div>
        </>
      )}
      {user?.permissionMap.download_sendreports && (
        <>
          <Divider className="divider" />
          <div className="popover-field">
            <div className="field-options">
              <Button
                className="field-button"
                type="text"
                icon={<DownloadOutlined />}
                onClick={onDownloadClick}
              >
                Download
              </Button>
            </div>
          </div>
        </>
      )}
      {tab === "available" && (
        <>
          <Divider className="divider" />
          <div className="popover-field">
            <div className="field-options">
              <Button
                className="field-button"
                type="text"
                icon={<DeleteOutlined />}
                onClick={onRemoveClick}
              >
                <span className="remove">Remove</span>
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );

  return (
    <div className="SendReportActionContainer">
      <span className="counter-text">{`${counter} selected`}</span>
      <Popover
        placement="bottom"
        overlayClassName="SendReportActionPopover"
        arrow={false}
        content={counter === 0 ? null : actionPopupMenu}
      >
        <Button
          icon={<MoreOutlined />}
          className="actionButton"
          iconPosition="end"
          disabled={loading || counter === 0}
        >
          Actions
        </Button>
      </Popover>
    </div>
  );
}
